import { Typography } from "@mui/material";

import { withForm } from "components/Forms/AppForm";
import { defaultMailListValues } from "features/memberPortal/mail/components/MailList/MailList.schema";

import { DetailCardMode } from "../MailListDetails.types";

const DetailCardDescription = withForm({
  defaultValues: defaultMailListValues,
  props: {
    description: "",
    mode: "view" as DetailCardMode,
  },
  render: ({ form, description, mode }) => {
    if (mode === "view") {
      return (
        <Typography
          sx={{
            fontStyle: "italic",
          }}
          color="secondary"
        >
          {description}
        </Typography>
      );
    }

    return (
      <form.AppField name="description">
        {(field) => <field.TextInput label="Description" required />}
      </form.AppField>
    );
  },
});

export default DetailCardDescription;
